import { useEffect, useState } from 'react'

import { getTechs } from '../api'
import { useAppDispatch } from '@sales-center/common'

export function useGetTechsOnMount() {
  const [loading, setLoading] = useState(true)

  const dispatch = useAppDispatch()

  useEffect(() => {
    let mounted = true

    const execute = async () => {
      try {
        await dispatch(getTechs(undefined))
      } catch {
      } finally {
        if (mounted) setLoading(false)
      }
    }
    execute()

    return () => {
      mounted = false
    }
  }, [dispatch])

  return loading
}
